import React, { PureComponent } from "react";
import "./App.css";
import Address from "../containers/Address";
import Complete from "./Complete";
import Logo from "./Logo";
import Spinner from "./Spinner";

class App extends PureComponent {
  renderContent() {
    const {
      loaded,
      updated,
      updating,
      clienttype,
    } = this.props;
    if (!loaded) {
      return <Spinner />;
    }
    if (updated) {
      return <Complete clienttype={clienttype} />;
    }

    if (updating) {
      return (
        <div>
          <Spinner />
          <p>
            Please allow several minutes for us to configure Wi-Fi Calling on
            your account...
          </p>
        </div>
      );
    }

    return (
      <div>
        <h2>Emergency 911 Address</h2>
        <Address />
      </div>
    );
    

  }
  render() {
    const { brand } = this.props;
    const brandName = brand ? brand.name : undefined;
    return (
      <div className={"App App--" + brandName}>
        <div>
          <h1>
            <Logo brandName={brandName} />
            Wi-Fi Calling
          </h1>
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

export default App;
